'use client'

import { buttonVariants } from '@eversports/klimt-primitives/Button/Button'
import { useFirstUserInteraction } from '@eversports/klimt-utilities/use-first-user-interaction'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import { cn } from '../../../../lib/utils'
import getGraphqlForClient from '../../../lib/get-graphql-for-client'

import DesktopUserMenu from './DesktopUserMenu'
import MobileUserMenu from './MobileUserMenu'
import { AuthRoutes, LoggedInUserMenuItems } from './UserMenu.constants'
import { User } from './UserMenu.types'

const UserMenu = () => {
  const client = getGraphqlForClient()
  const t = useTranslations('header')

  const [userData, setUserData] = useState<User | null>()
  const [authUrlParams, setAuthUrlParams] = useState('')

  const handleInteraction = () => {
    setAuthUrlParams(
      `?origin=eversport&redirectPath=${encodeURIComponent(window.location.pathname + window.location.search)}`,
    )
  }

  const { handleFirstInteraction } = useFirstUserInteraction({ element: window.document, handleInteraction })

  useEffect(() => {
    handleFirstInteraction()
  }, [])

  useEffect(() => {
    void client.UserMenuMe().then((data) => {
      setUserData(data.me)
    })
  }, [client])

  if (userData === undefined) {
    return null
  }
  if (userData) {
    const hasCorporateBenefits = Boolean(userData.corporateBenefits?.__typename)
    const menuItems = LoggedInUserMenuItems({ userHandle: userData.handle, hasCorporateBenefits })
    return (
      <>
        <DesktopUserMenu user={userData} menuItems={menuItems} />
        <MobileUserMenu user={userData} menuItems={menuItems} />
      </>
    )
  }
  return (
    <div className="flex gap-1">
      <a
        href={`${AuthRoutes.LOGIN}${authUrlParams}`}
        className={cn('h-fit rounded px-2 py-0.5', buttonVariants({ variant: 'default' }))}
      >
        {t('login')}
      </a>
      <a
        href={`${AuthRoutes.REGISTER}${authUrlParams}`}
        className={cn('h-fit rounded px-2 py-0.5', buttonVariants({ variant: 'tertiary' }))}
      >
        {t('register')}
      </a>
    </div>
  )
}

export default UserMenu
